/* ============================================================
   assets/offsurge-size-chart.js
   OFFSURGE — Product Measurements size chart.

   - Loads ONLY from the injected <script id="offsurge-size-chart-data">.
   - No demo data, no template selector.
   - Inches are computed from cm (cm / 2.54).
   - Flat-measurement system: no circumference labels or notes.
   - Fails safe: if data is missing/invalid, the component is hidden
     and the product page is never broken.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1) GEOMETRY LIBRARY (keyed by measurement_key) ---------- */
  var ALIAS = { chest: 'bust' };
  var GEO = {
    top_sleeved: { viewBox: '0 0 360 410',
      paths: ['M152 60 L120 70 L78 104 L92 142 L128 128 L138 150 L122 366 L238 366 L222 150 L232 128 L268 142 L282 104 L240 70 L208 60 Z',
              'M152 60 Q180 88 208 60'],
      lines: { shoulder_width:{x1:120,y1:70,x2:240,y2:70,bx:120,by:48},
        bust:{x1:138,y1:170,x2:222,y2:170,bx:234,by:170},
        length:{x1:180,y1:60,x2:180,y2:366,bx:198,by:300,dash:1},
        sleeve_length:{x1:120,y1:70,x2:85,y2:123,bx:66,by:96},
        hem_width:{x1:122,y1:362,x2:238,y2:362,bx:250,by:362},
        arm_width:{x1:88,y1:128,x2:128,y2:128,bx:76,by:128} } },

    top_sleeveless: { viewBox: '0 0 360 410',
      paths: ['M156 62 L132 70 C122 108 132 150 142 162 L126 366 L234 366 L218 162 C228 150 238 108 228 70 L204 62 Q180 92 156 62 Z'],
      lines: { strap_length:{x1:156,y1:62,x2:132,y2:72,bx:142,by:50},
        shoulder_width:{x1:132,y1:70,x2:228,y2:70,bx:120,by:50},
        bust:{x1:142,y1:174,x2:218,y2:174,bx:230,by:174},
        length:{x1:180,y1:62,x2:180,y2:366,bx:198,by:300,dash:1},
        armhole_depth:{x1:140,y1:74,x2:142,y2:162,bx:120,by:118,dash:1},
        hem_width:{x1:126,y1:362,x2:234,y2:362,bx:246,by:362} } },

    top_off_shoulder: { viewBox: '0 0 360 410',
      paths: ['M112 84 L86 116 L104 142 L132 132 L138 152 L124 366 L236 366 L222 152 L228 132 L256 142 L274 116 L248 84 Q180 96 112 84 Z'],
      lines: { top_opening:{x1:112,y1:84,x2:248,y2:84,bx:118,by:62},
        bust:{x1:138,y1:174,x2:222,y2:174,bx:234,by:174},
        length:{x1:180,y1:90,x2:180,y2:366,bx:198,by:300,dash:1},
        sleeve_length:{x1:112,y1:84,x2:95,y2:128,bx:78,by:100},
        hem_width:{x1:124,y1:362,x2:236,y2:362,bx:248,by:362} } },

    outerwear: { viewBox: '0 0 360 410',
      paths: ['M152 60 L120 70 L78 104 L92 142 L128 128 L138 150 L122 366 L238 366 L222 150 L232 128 L268 142 L282 104 L240 70 L208 60 Z',
              'M168 62 L180 92 L192 62','M180 92 L180 364'],
      lines: { shoulder_width:{x1:120,y1:70,x2:240,y2:70,bx:120,by:48},
        bust:{x1:138,y1:172,x2:222,y2:172,bx:234,by:172},
        length:{x1:150,y1:62,x2:150,y2:364,bx:132,by:300,dash:1},
        sleeve_length:{x1:120,y1:70,x2:85,y2:123,bx:66,by:96},
        hem_width:{x1:122,y1:362,x2:238,y2:362,bx:250,by:362},
        arm_width:{x1:88,y1:128,x2:128,y2:128,bx:76,by:128} } },

    dress_sleeved: { viewBox: '0 0 360 540',
      paths: ['M152 60 L120 72 L92 112 L122 124 L138 154 L150 250 L124 336 L98 502 L262 502 L236 336 L210 250 L222 154 L238 124 L268 112 L240 72 L208 60 Q180 86 152 60 Z'],
      lines: { bust:{x1:138,y1:172,x2:222,y2:172,bx:234,by:172},
        waist:{x1:150,y1:252,x2:210,y2:252,bx:222,by:252},
        hip:{x1:124,y1:336,x2:236,y2:336,bx:248,by:336},
        length:{x1:180,y1:60,x2:180,y2:502,bx:198,by:420,dash:1},
        sleeve_length:{x1:120,y1:72,x2:100,y2:118,bx:84,by:96},
        hem_sweep:{x1:98,y1:498,x2:262,y2:498,bx:276,by:498} } },

    dress_sleeveless: { viewBox: '0 0 360 540',
      paths: ['M156 62 L132 72 C124 100 134 130 140 154 L150 250 L124 336 L98 502 L262 502 L236 336 L210 250 L220 154 C226 130 236 100 228 72 L204 62 Q180 90 156 62 Z'],
      lines: { strap_length:{x1:156,y1:62,x2:132,y2:72,bx:142,by:50},
        bust:{x1:140,y1:174,x2:220,y2:174,bx:232,by:174},
        waist:{x1:150,y1:252,x2:210,y2:252,bx:222,by:252},
        hip:{x1:124,y1:336,x2:236,y2:336,bx:248,by:336},
        length:{x1:180,y1:62,x2:180,y2:502,bx:198,by:420,dash:1},
        hem_sweep:{x1:98,y1:498,x2:262,y2:498,bx:276,by:498} } },

    dress_off_shoulder: { viewBox: '0 0 360 540',
      paths: ['M112 86 L88 118 L106 144 L134 134 L140 156 L150 252 L124 338 L98 502 L262 502 L236 338 L210 252 L220 156 L226 134 L254 144 L272 118 L248 86 Q180 98 112 86 Z'],
      lines: { top_opening:{x1:112,y1:86,x2:248,y2:86,bx:118,by:64},
        bust:{x1:140,y1:176,x2:220,y2:176,bx:232,by:176},
        waist:{x1:150,y1:254,x2:210,y2:254,bx:222,by:254},
        hip:{x1:124,y1:338,x2:236,y2:338,bx:248,by:338},
        length:{x1:180,y1:92,x2:180,y2:502,bx:198,by:420,dash:1},
        hem_sweep:{x1:98,y1:498,x2:262,y2:498,bx:276,by:498} } },

    pants: { viewBox: '0 0 360 480',
      paths: ['M124 52 L236 52 L242 120 L234 448 L196 448 L180 214 L164 448 L126 448 L118 120 Z','M124 60 L236 60'],
      lines: { waist:{x1:124,y1:56,x2:236,y2:56,bx:124,by:38},
        hip:{x1:118,y1:124,x2:242,y2:124,bx:254,by:124},
        front_rise:{x1:180,y1:214,x2:180,y2:54,bx:198,by:140,dash:1},
        inseam:{x1:180,y1:214,x2:166,y2:444,bx:152,by:330,dash:1},
        outseam:{x1:120,y1:58,x2:128,y2:446,bx:104,by:250,dash:1},
        thigh:{x1:121,y1:234,x2:178,y2:234,bx:108,by:234},
        leg_opening:{x1:127,y1:442,x2:164,y2:442,bx:112,by:442} } },

    skirt: { viewBox: '0 0 360 420',
      paths: ['M132 60 L228 60 L236 96 L268 360 L92 360 L124 96 Z','M132 70 L228 70'],
      lines: { waist:{x1:132,y1:64,x2:228,y2:64,bx:132,by:46},
        hip:{x1:124,y1:98,x2:236,y2:98,bx:248,by:98},
        length:{x1:180,y1:60,x2:180,y2:360,bx:198,by:240,dash:1},
        hem_sweep:{x1:92,y1:356,x2:268,y2:356,bx:282,by:356},
        slit_length:{x1:208,y1:356,x2:208,y2:300,bx:224,by:328,dash:1} } },

    jumpsuit: { viewBox: '0 0 360 560',
      paths: ['M152 60 L120 72 L92 112 L122 124 L138 150 L130 320 L124 360 L128 540 L166 540 L180 372 L194 540 L232 540 L236 360 L230 320 L222 150 L238 124 L268 112 L240 72 L208 60 Q180 86 152 60 Z'],
      lines: { bust:{x1:138,y1:170,x2:222,y2:170,bx:234,by:170},
        waist:{x1:131,y1:316,x2:229,y2:316,bx:241,by:316},
        hip:{x1:124,y1:360,x2:236,y2:360,bx:248,by:360},
        torso_length:{x1:180,y1:60,x2:180,y2:360,bx:198,by:200,dash:1},
        inseam:{x1:180,y1:372,x2:168,y2:536,bx:154,by:455,dash:1},
        sleeve_length:{x1:120,y1:72,x2:100,y2:118,bx:84,by:96},
        leg_opening:{x1:128,y1:536,x2:166,y2:536,bx:114,by:536} } }
  };

  /* ---------- 2) COPY DICTIONARIES ---------- */
  var HOWTO = {
    shoulder_width:'Measure straight across the back from shoulder seam to shoulder seam.',
    bust:'Measure straight across the garment from underarm to underarm.',
    chest:'Measure straight across the garment from underarm to underarm.',
    waist:'Measure straight across the waistband or narrowest point.',
    hip:'Measure straight across the widest part of the garment.',
    length:'Measure from the highest shoulder point straight down to the hem.',
    sleeve_length:'Measure from the shoulder seam to the end of the sleeve.',
    hem_width:'Measure straight across the bottom hem of the garment.',
    arm_width:'Measure straight across the sleeve at its widest point.',
    strap_length:'Measure the strap from front to back over the shoulder.',
    armhole_depth:'Measure vertically from the shoulder to the base of the armhole.',
    top_opening:'Measure straight across the top opening edge.',
    front_rise:'Measure from the crotch seam up to the top of the waistband.',
    inseam:'Measure from the crotch seam down to the leg opening.',
    outseam:'Measure from the top of the waistband down to the leg opening.',
    thigh:'Measure straight across the leg just below the crotch seam.',
    leg_opening:'Measure straight across the bottom hem of the leg.',
    hem_sweep:'Measure straight across the full hem opening.',
    slit_length:'Measure the slit from the hem up to its top.',
    torso_length:'Measure from the shoulder down to the crotch seam.'
  };
  // Customer-facing value-type labels (flat system; no circumference).
  var VTYPE = { flat:'Laid flat', vertical:'Top to bottom', diagonal:'Angled measurement' };

  /* ---------- 3) STATE ---------- */
  var root, CONFIG, GEOM, SIZES, ROWS, unit, size;
  function $(id){ return document.getElementById(id); }
  function hideRoot(){ if (root){ root.setAttribute('data-state','error'); } }

  function resolveLine(key){ var L = GEOM.lines; return L[key] || L[ALIAS[key]]; }

  // Inches computed automatically from cm.
  function getVal(rowObj, sz){
    var cm = rowObj.values_cm ? rowObj.values_cm[sz] : null;
    if (cm === null || cm === undefined || isNaN(cm)) return '—';
    cm = parseFloat(cm);
    return (unit === 'cm' ? cm : cm / 2.54).toFixed(1);
  }

  /* ---------- 4) RENDER ---------- */
  function dimLine(ln, code){
    var dx = ln.x2 - ln.x1, dy = ln.y2 - ln.y1, len = Math.hypot(dx, dy) || 1;
    var nx = -dy / len * 5, ny = dx / len * 5;
    function tick(x, y){
      return '<line class="osc-tick" x1="'+(x-nx).toFixed(1)+'" y1="'+(y-ny).toFixed(1)+'" x2="'+(x+nx).toFixed(1)+'" y2="'+(y+ny).toFixed(1)+'"/>';
    }
    return '<g class="osc-dim" data-dim="'+code+'">'
      + '<line class="osc-lead'+(ln.dash?' is-dash':'')+'" x1="'+ln.x1+'" y1="'+ln.y1+'" x2="'+ln.x2+'" y2="'+ln.y2+'"/>'
      + tick(ln.x1, ln.y1) + tick(ln.x2, ln.y2)
      + '<circle class="osc-bdg" cx="'+ln.bx+'" cy="'+ln.by+'" r="11"/>'
      + '<text class="osc-bdgt" x="'+ln.bx+'" y="'+ln.by+'" text-anchor="middle" dominant-baseline="central">'+code+'</text></g>';
  }

  function renderDrawing(){
    var s = '<svg viewBox="'+GEOM.viewBox+'" xmlns="http://www.w3.org/2000/svg">';
    GEOM.paths.forEach(function(p, i){ s += '<path class="osc-garment'+(i>0?' is-detail':'')+'" d="'+p+'"/>'; });
    ROWS.forEach(function(m){ var ln = resolveLine(m.measurement_key); if (ln) s += dimLine(ln, m.code); });
    s += '</svg>';
    $('osc-drawing').innerHTML = s;
    Array.prototype.forEach.call($('osc-drawing').querySelectorAll('.osc-dim'), function(el){
      var c = el.getAttribute('data-dim');
      el.addEventListener('mouseenter', function(){ highlight(c, true); });
      el.addEventListener('mouseleave', function(){ highlight(c, false); });
    });
  }

  function miniSVG(key){
    var ln = resolveLine(key), s = '<svg viewBox="'+GEOM.viewBox+'">';
    GEOM.paths.forEach(function(p){ s += '<path class="osc-gm" d="'+p+'"/>'; });
    if (ln){
      s += '<line class="osc-hl-line" x1="'+ln.x1+'" y1="'+ln.y1+'" x2="'+ln.x2+'" y2="'+ln.y2+'"/>';
      var dx = ln.x2-ln.x1, dy = ln.y2-ln.y1, len = Math.hypot(dx,dy)||1, nx = -dy/len*6, ny = dx/len*6;
      [[ln.x1,ln.y1],[ln.x2,ln.y2]].forEach(function(p){
        s += '<line class="osc-hl-line" x1="'+(p[0]-nx)+'" y1="'+(p[1]-ny)+'" x2="'+(p[0]+nx)+'" y2="'+(p[1]+ny)+'"/>';
      });
    }
    return s + '</svg>';
  }

  function renderPills(){
    var p = $('osc-pills');
    p.style.gridTemplateColumns = 'repeat('+SIZES.length+',1fr)';
    p.innerHTML = SIZES.map(function(s){
      return '<button type="button" data-s="'+s+'" class="'+(s===size?'is-active':'')+'">'+s+'</button>';
    }).join('');
    Array.prototype.forEach.call(p.querySelectorAll('button'), function(b){
      b.addEventListener('click', function(){ setSize(b.getAttribute('data-s')); });
    });
  }

  function renderCards(){
    $('osc-cards').innerHTML = ROWS.map(function(m){
      var vt = VTYPE[m.value_type] || '';
      return '<div class="osc-mcard" data-link="'+m.code+'">'
        + '<div class="osc-ml"><span class="osc-code">'+m.code+'</span>'+esc(m.label)+'</div>'
        + '<div class="osc-mv">'+getVal(m, size)+'<small>'+unit+'</small></div>'
        + (vt ? '<div class="osc-vtype">'+vt+'</div>' : '')
        + '</div>';
    }).join('');
    bindLinks('#osc-cards .osc-mcard');
  }

  function renderChart(){
    var crow = $('osc-crow');
    crow.style.gridTemplateColumns = '1.7fr repeat('+SIZES.length+',1fr)';
    var h = '<div class="osc-ch">Measurement</div>'
      + SIZES.map(function(s){ return '<div class="osc-ch osc-size '+(s===size?'is-col-active':'')+'" data-s="'+s+'">'+s+'</div>'; }).join('');
    ROWS.forEach(function(m, i){
      var f = i === 0 ? ' is-first' : '';
      h += '<div class="osc-cn'+f+'" data-link="'+m.code+'"><span class="osc-code">'+m.code+'</span>'+esc(m.label)+'</div>';
      h += SIZES.map(function(s){
        return '<div class="osc-cv'+f+' '+(s===size?'is-col-active':'')+'" data-col="'+s+'">'+getVal(m, s)+'</div>';
      }).join('');
    });
    crow.innerHTML = h;
    Array.prototype.forEach.call(crow.querySelectorAll('.osc-ch.osc-size'), function(b){
      b.addEventListener('click', function(){ setSize(b.getAttribute('data-s')); });
    });
    bindLinks('#osc-crow .osc-cn');
  }

  function renderHowto(){
    $('osc-hgrid').innerHTML = ROWS.map(function(m){
      var txt = m.how_to_measure || HOWTO[m.measurement_key] || 'Measure point to point with the garment laid flat.';
      return '<div class="osc-hitem" data-link="'+m.code+'">'
        + '<div class="osc-hmini">'+miniSVG(m.measurement_key)+'</div>'
        + '<div class="osc-htxt"><h4><span class="osc-code">'+m.code+'</span>'+esc(m.label)+'</h4><p>'+esc(txt)+'</p></div>'
        + '</div>';
    }).join('');
    bindLinks('#osc-hgrid .osc-hitem');
  }

  function renderNotes(){
    var footer = CONFIG.footer_note || 'This is a garment measurement chart, not a body measurement chart.';
    var h = ''
      + '<p class="osc-note"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#A6A49B" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M7 12h10"/></svg>Measurements are taken flat across the garment unless stated otherwise.</p>'
      + '<p class="osc-note"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#A6A49B" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><circle cx="12" cy="7.6" r=".4" fill="#A6A49B" stroke="none"/></svg><span>'+esc(footer)+' Compare these with a similar item you already own.</span></p>';
    $('osc-notes').innerHTML = h;
  }

  /* ---------- 5) INTERACTION ---------- */
  function bindLinks(sel){
    Array.prototype.forEach.call(root.querySelectorAll(sel), function(el){
      var c = el.getAttribute('data-link');
      el.addEventListener('mouseenter', function(){ highlight(c, true); });
      el.addEventListener('mouseleave', function(){ highlight(c, false); });
    });
  }
  function highlight(code, on){
    Array.prototype.forEach.call(root.querySelectorAll('.osc-dim[data-dim="'+code+'"]'), function(e){ e.classList.toggle('is-active', on); });
    Array.prototype.forEach.call(root.querySelectorAll('[data-link="'+code+'"]'), function(e){ e.classList.toggle('is-hl', on); });
  }
  function selectedProductSize(){
    var picker = document.querySelector('variant-picker');
    if (!picker || !SIZES) return null;
    var selected = Array.from(picker.querySelectorAll('input:checked, select option:checked'));
    return selected.map(function(input){ return input.value; }).find(function(value){ return SIZES.indexOf(value) >= 0; }) || null;
  }
  function setSize(s){
    size = s;
    renderPills();
    renderCards();
    Array.prototype.forEach.call(root.querySelectorAll('#osc-crow .osc-cv, #osc-crow .osc-ch.osc-size'), function(c){
      var v = c.getAttribute('data-col') || c.getAttribute('data-s');
      c.classList.toggle('is-col-active', v === s);
    });
  }
  function esc(str){
    return String(str == null ? '' : str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  /* ---------- 6) BOOT ---------- */
  function init(){
    root = $('offsurge-sc');
    var node = $('offsurge-size-chart-data');
    if (!root || !node) { hideRoot(); return; }

    // Parse the injected config
    try { CONFIG = JSON.parse(node.textContent); }
    catch (e) { hideRoot(); return; }
    if (!CONFIG) { hideRoot(); return; }

    // chart_data may arrive as an object or a JSON string
    var cd = CONFIG.chart_data;
    if (typeof cd === 'string') { try { cd = JSON.parse(cd); } catch (e) { cd = null; } }
    var rows = cd && Array.isArray(cd.measurement_rows) ? cd.measurement_rows : null;
    if (!rows || !rows.length) { hideRoot(); return; }

    // Template geometry (fail safe if unknown)
    GEOM = GEO[CONFIG.garment_template];
    if (!GEOM) { hideRoot(); return; }

    // Sort by display_order, then assign fallback A/B/C codes
    ROWS = rows.slice().sort(function(a, b){
      return (a.display_order == null ? 0 : a.display_order) - (b.display_order == null ? 0 : b.display_order);
    }).map(function(rowObj, i){
      var copy = {};
      for (var k in rowObj){ if (Object.prototype.hasOwnProperty.call(rowObj, k)) copy[k] = rowObj[k]; }
      if (!copy.code) copy.code = String.fromCharCode(65 + i);
      return copy;
    });

    SIZES = Array.isArray(CONFIG.size_labels) && CONFIG.size_labels.length ? CONFIG.size_labels : ['S','M','L','XL'];
    unit  = CONFIG.default_unit === 'in' ? 'in' : 'cm';
    size = selectedProductSize() || SIZES[0];

    // Header note
    $('osc-mainNote').textContent = CONFIG.main_note ||
      'Garment measurements are taken flat. Compare with a similar item you own for the best fit.';

    // Unit toggle: hide if explicitly disabled
    var ut = $('osc-unit');
    if (CONFIG.show_unit_toggle === false) {
      ut.style.display = 'none';
    } else {
      ut.setAttribute('data-u', unit);
      Array.prototype.forEach.call(ut.querySelectorAll('button'), function(x){
        x.classList.toggle('is-active', x.getAttribute('data-u') === unit);
      });
      ut.querySelectorAll('button').forEach && ut.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          unit = b.getAttribute('data-u');
          ut.setAttribute('data-u', unit);
          Array.prototype.forEach.call(ut.querySelectorAll('button'), function(x){
            x.classList.toggle('is-active', x.getAttribute('data-u') === unit);
          });
          renderCards();
          renderChart();
        });
      });
    }

    // Collapse comparison by default on small screens
    if (window.matchMedia && window.matchMedia('(max-width:480px)').matches) {
      var cmp = $('osc-compare'); if (cmp) cmp.open = false;
    }

    renderDrawing();
    renderPills();
    renderCards();
    renderChart();
    renderHowto();
    renderNotes();

    document.addEventListener('change', function(event){
      if (event.target.closest('variant-picker')) {
        var selected = selectedProductSize();
        if (selected) setSize(selected);
      }
    });
    root.setAttribute('data-state', 'ready');
  }

  // `defer` guarantees DOM is parsed, but guard anyway.
  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ try { init(); } catch (e) { hideRoot(); } });
    } else {
      init();
    }
  } catch (e) { hideRoot(); }
})();
